import { render } from "./IconFont.vue?vue&type=template&id=7c4eab63"
import script from "./IconFont.vue?vue&type=script&lang=js"
export * from "./IconFont.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__